import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useI18n } from "../i18n";
import { useCity } from "../context/CityContext";

export function CookieBanner() {
  const { t } = useI18n();
  const { modalOpen } = useCity();
  const [ok, setOk] = useState(() => localStorage.getItem("stuff_cookie_ok") === "1");
  const [ageOk, setAgeOk] = useState(() => localStorage.getItem("stuff_age_ok") === "1");
  useEffect(() => {
    if (ageOk) return undefined;
    const timer = setInterval(() => { if (localStorage.getItem("stuff_age_ok") === "1") setAgeOk(true); }, 500);
    return () => clearInterval(timer);
  }, [ageOk]);
  if (ok || !ageOk || modalOpen) return null;
  const accept = () => { localStorage.setItem("stuff_cookie_ok", "1"); setOk(true); };
  return (
    <div data-testid="cookie-banner" className="fixed bottom-3 right-3 left-3 sm:left-auto z-[60] max-w-sm bg-ink-surface/95 backdrop-blur border border-zinc-700 rounded-lg px-3 py-2.5 shadow-xl">
      <div className="flex items-center gap-2">
        <Cookie className="h-4 w-4 text-neon-green shrink-0" />
        <p className="text-zinc-400 text-[11px] sm:text-xs leading-snug flex-1 line-clamp-2 sm:line-clamp-none">{t("cookie.text")}{" "}
          <Link to="/confidentialite" className="text-neon-green underline hover:text-neon-magenta">{t("cookie.more")}</Link>
        </p>
        <button data-testid="cookie-accept" onClick={accept} className="shrink-0 bg-neon-green text-black font-bold uppercase text-[11px] px-3 py-1.5 hover:bg-neon-greenDark transition-colors">{t("cookie.ok")}</button>
      </div>
    </div>
  );
}
